import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getCheckout } from 'src/redux/shoppingcart'
import { cibWhatsapp, cilInfo, cilTouchApp } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import {
  CButton,
  CButtonGroup,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from '@coreui/react'
import { DateTimeConverter } from 'src/utils/function'

const AbandonedCart = () => {
  const [selectedProduct, setSelectedProduct] = useState(null)
  const [modalVisible, setModalVisible] = useState(false)

  const [selectedInfo, setSelectedInfo] = useState(null)
  const [modalVisible2, setModalVisible2] = useState(false)

  const dispatch = useDispatch()
  const { checkoutItems } = useSelector((state) => state.shoppingcart)

  console.log(checkoutItems)

  useEffect(() => {
    dispatch(getCheckout())
  }, [dispatch])

  const handleProductView = (product) => {
    setSelectedProduct(product)
    setModalVisible(true)
  }

  const handleInfoView = (info) => {
    setSelectedInfo(info)
    setModalVisible2(true)
  }

  return (
    <div className="bg-light d-flex flex-row align-items-center">
      <CContainer>
        <CTable align="middle" className="mb-0 border" hover responsive>
          <CTableHead color="light">
            <CTableRow>
              <CTableHeaderCell>Name</CTableHeaderCell>
              <CTableHeaderCell>Checkout</CTableHeaderCell>
              <CTableHeaderCell className="text-center">Total Amount</CTableHeaderCell>
              <CTableHeaderCell className="text-center">Delivery Charges</CTableHeaderCell>
              <CTableHeaderCell className="text-center">Coupon</CTableHeaderCell>
              <CTableHeaderCell className="text-center">Payment</CTableHeaderCell>
              <CTableHeaderCell className="text-center">Shipping</CTableHeaderCell>
              <CTableHeaderCell className="text-center">Date Slot</CTableHeaderCell>
              <CTableHeaderCell className="text-center">Time Slot</CTableHeaderCell>
              <CTableHeaderCell className="text-center">Action</CTableHeaderCell>
            </CTableRow>
          </CTableHead>
          <CTableBody>
            {checkoutItems?.map((item, index) => (
              <CTableRow key={index}>
                <CTableDataCell>{item.name}</CTableDataCell>
                <CTableDataCell>{DateTimeConverter(item.checkout_date)}</CTableDataCell>
                <CTableDataCell className="text-center">₹{item.total_amount}</CTableDataCell>
                <CTableDataCell className="text-center">₹{item.delivery_charges}</CTableDataCell>
                <CTableDataCell className="text-center">
                  ₹{item.coupons_discount || '0.00'}
                </CTableDataCell>
                <CTableDataCell className="text-center">{item.payment_method}</CTableDataCell>
                <CTableDataCell className="text-center">{item.shipping_method}</CTableDataCell>
                <CTableDataCell className="text-center">{item.date_slot}</CTableDataCell>
                <CTableDataCell className="text-center">{item.time_slot}</CTableDataCell>
                <CTableDataCell className="text-center">
                  <CButtonGroup role="group">
                    <CButton
                      color="info"
                      size="sm"
                      onClick={() => handleProductView(item.cart_details)}
                    >
                      <CIcon icon={cilTouchApp} className="text-white" />
                    </CButton>
                    <CButton
                      color="success"
                      size="sm"
                      onClick={() => console.log(item.whatsapp_no)}
                    >
                      <CIcon icon={cibWhatsapp} className="text-white" />
                    </CButton>
                    <CButton color="secondary" size="sm" onClick={() => handleInfoView(item)}>
                      <CIcon icon={cilInfo} className="text-white" />
                    </CButton>
                  </CButtonGroup>
                </CTableDataCell>
              </CTableRow>
            ))}
          </CTableBody>
        </CTable>
      </CContainer>

      <CModal size="lg" visible={modalVisible} onClose={() => setModalVisible(false)}>
        <CModalHeader closeButton>
          <CModalTitle>Product Details</CModalTitle>
        </CModalHeader>
        <CModalBody>
          {selectedProduct ? (
            <CTable hover responsive>
              <CTableHead>
                <CTableRow>
                  <CTableHeaderCell>Product Name</CTableHeaderCell>
                  <CTableHeaderCell>Weight</CTableHeaderCell>
                  <CTableHeaderCell>Pieces</CTableHeaderCell>
                  <CTableHeaderCell>Serves</CTableHeaderCell>
                  <CTableHeaderCell>Stock</CTableHeaderCell>
                  <CTableHeaderCell>Quantity</CTableHeaderCell>
                  <CTableHeaderCell>Price</CTableHeaderCell>
                  <CTableHeaderCell>Discount</CTableHeaderCell>
                  <CTableHeaderCell>Image</CTableHeaderCell>
                </CTableRow>
              </CTableHead>
              <CTableBody>
                {selectedProduct.map((product, idx) => (
                  <CTableRow key={idx}>
                    <CTableDataCell>{product.product_details.name}</CTableDataCell>
                    <CTableDataCell>{product.product_details.weight}</CTableDataCell>
                    <CTableDataCell>{product.product_details.pieces}</CTableDataCell>
                    <CTableDataCell>{product.product_details.serves}</CTableDataCell>
                    <CTableDataCell>{product.product_details.stock}</CTableDataCell>
                    <CTableDataCell>{product.quantity}</CTableDataCell>
                    <CTableDataCell>₹{product.price}</CTableDataCell>
                    <CTableDataCell>₹{product.discount || '0.00'}</CTableDataCell>
                    <CTableDataCell>
                      <img
                        src={product.product_details.images}
                        alt={product.product_details.name}
                        style={{ width: '50px', height: '50px', borderRadius: 10 }}
                      />
                    </CTableDataCell>
                  </CTableRow>
                ))}
              </CTableBody>
            </CTable>
          ) : (
            <p>No product details available</p>
          )}
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={() => setModalVisible(false)}>
            Close
          </CButton>
        </CModalFooter>
      </CModal>

      <CModal size="xl" visible={modalVisible2} onClose={() => setModalVisible2(false)}>
        <CModalHeader closeButton>
          <CModalTitle>Billing Details</CModalTitle>
        </CModalHeader>
        <CModalBody>
          {selectedInfo ? (
            <CTable hover responsive>
              <CTableHead>
                <CTableRow>
                  <CTableHeaderCell>Username</CTableHeaderCell>
                  <CTableHeaderCell>Mobile</CTableHeaderCell>
                  <CTableHeaderCell>Email</CTableHeaderCell>
                  {/* <CTableHeaderCell>City</CTableHeaderCell> */}
                  {/* <CTableHeaderCell>State</CTableHeaderCell> */}
                  {/* <CTableHeaderCell>Country</CTableHeaderCell> */}
                  <CTableHeaderCell>Address</CTableHeaderCell>
                  <CTableHeaderCell>Billing-address</CTableHeaderCell>
                  <CTableHeaderCell>Shipping-address</CTableHeaderCell>
                  <CTableHeaderCell>Created</CTableHeaderCell>
                  {/* <CTableHeaderCell>Updated</CTableHeaderCell> */}
                  {/* <CTableHeaderCell>Geo-location</CTableHeaderCell> */}
                </CTableRow>
              </CTableHead>
              <CTableBody>
                <CTableRow>
                  <CTableDataCell>{selectedInfo.username}</CTableDataCell>
                  <CTableDataCell>{selectedInfo.mobile_no}</CTableDataCell>
                  <CTableDataCell>{selectedInfo.email_id || 'NA'}</CTableDataCell>
                  {/* <CTableDataCell>{selectedInfo.city}</CTableDataCell> */}
                  {/* <CTableDataCell>{selectedInfo.state}</CTableDataCell> */}
                  {/* <CTableDataCell>{selectedInfo.country}</CTableDataCell> */}
                  <CTableDataCell>{selectedInfo.address}</CTableDataCell>
                  <CTableDataCell>{selectedInfo.billing_address}</CTableDataCell>
                  <CTableDataCell>{selectedInfo.shipping_address}</CTableDataCell>
                  <CTableDataCell>{DateTimeConverter(selectedInfo.createdAt)}</CTableDataCell>
                  {/* <CTableDataCell>{DateTimeConverter(selectedInfo.updatedAt)}</CTableDataCell> */}
                  {/* <CTableDataCell>{selectedInfo.geolocation}</CTableDataCell> */}
                </CTableRow>
              </CTableBody>
            </CTable>
          ) : (
            <p>No users details available</p>
          )}
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={() => setModalVisible2(false)}>
            Close
          </CButton>
        </CModalFooter>
      </CModal>
    </div>
  )
}

export default AbandonedCart
